import { mergeStyleSets } from '@uifabric/merge-styles';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  root: {
    minWidth: '-webkit-fill-available',
    display: 'flex',
    justifyContent: 'space-between',
    clear: 'both',
    margin: `0 ${pxToRem(24)} 0 ${pxToRem(24)}`,
    borderBottom: `1px solid ${theme.palette.themePrimary}`,
    position: 'relative',
  },
  name: {
    color: theme.palette.neutralSecondary,
    float: 'left',
    wordBreak: 'break-word',
    padding: `${pxToRem(5)} 0 ${pxToRem(7)} ${pxToRem(16)}`,
    height: '50px',
    selectors: {
      '& p': {
        fontWeight: 'bold',
      },
    },
  },
  purchasedUnits: {
    position: 'absolute',
    color: theme.palette.neutralSecondary,
    wordBreak: 'break-word',
    left: '25%',
    width: '11%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  returnCap: {
    position: 'absolute',
    color: theme.palette.neutralSecondary,
    wordBreak: 'break-word',
    left: '35%',
    width: '7%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  capLimit: {
    position: 'absolute',
    color: theme.palette.neutralSecondary,
    wordBreak: 'break-word',
    left: '45%',
    width: '6%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  actualReturns: {
    position: 'absolute',
    color: theme.palette.neutralSecondary,
    wordBreak: 'break-word',
    left: '55%',
    width: '10%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  returnsOverCap: {
    position: 'absolute',
    color: theme.palette.neutralSecondary,
    wordBreak: 'break-word',
    left: '65%',
    width: '9%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  returnsIncluded: {
    position: 'absolute',
    color: theme.palette.neutralSecondary,
    wordBreak: 'break-word',
    left: '75%',
    width: '11%',
    selectors: {
      '& span': {
        fontWeight: 'bold',
      },
    },
  },
  amount: {
    float: 'right',
    color: theme.palette.neutralSecondary,
    padding: `${pxToRem(5)} ${pxToRem(16)} ${pxToRem(7)} 0`,
    selectors: {
      '& p': {
        fontWeight: 'bold',
      },
    },
  },
  percapAmount: {
    width: '10%',
  },
  details: {
    fontSize: pxToRem(12),
    fontWeight: 'normal',
    color: theme.palette.neutralSecondary,
    padding: `${pxToRem(7)} 0 ${pxToRem(9)} ${pxToRem(24)}`,
  },
});
